var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66659 5.50065H1.83325V18.334C1.83325 18.8202 2.02641 19.2865 2.37022 19.6303C2.71404 19.9742 3.18036 20.1673 3.66659 20.1673H16.4999V18.334H3.66659V5.50065ZM16.9583 13.0632C16.9583 11.6882 14.2083 11.0007 12.8333 11.0007C11.4583 11.0007 8.70825 11.6882 8.70825 13.0632V13.7507H16.9583M12.8333 9.39648C13.9699 9.39648 14.8958 8.47065 14.8958 7.33398C14.8958 6.19732 13.9699 5.27148 12.8333 5.27148C11.6966 5.27148 10.7708 6.19732 10.7708 7.33398C10.7708 8.47065 11.6966 9.39648 12.8333 9.39648ZM18.3333 1.83398H7.33325C6.32492 1.83398 5.49992 2.65898 5.49992 3.66732V14.6673C5.49992 15.1535 5.69307 15.6199 6.03689 15.9637C6.38071 16.3075 6.84702 16.5007 7.33325 16.5007H18.3333C19.3508 16.5007 20.1666 15.6848 20.1666 14.6673V3.66732C20.1666 3.18109 19.9734 2.71477 19.6296 2.37096C19.2858 2.02714 18.8195 1.83398 18.3333 1.83398ZM18.3333 14.6673H7.33325V3.66732H18.3333V14.6673Z",
    fill: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBox);
export default __webpack_public_path__ + "static/media/multi-box.20434a8296f40b4102dfd6d46e2a15ff.svg";
export { ForwardRef as ReactComponent };